// Strips Markdown syntax (bold/italic/headings/tables) out of explanation text so
// speech synthesis doesn't read literal characters like "asterisk" or "pipe" aloud.
export function toSpeechText(markdown: string): string {
  const spoken: string[] = [];

  for (const raw of markdown.split('\n')) {
    const line = raw.trim();
    if (!line) continue;

    // Table separator row, e.g. |------|---|---|
    if (/^\|?[\s:|-]+\|?$/.test(line) && line.includes('-')) continue;

    if (line.startsWith('|') && line.endsWith('|')) {
      const cells = line.slice(1, -1).split('|').map(c => c.trim()).filter(Boolean);
      if (cells.length) spoken.push(cells.join(', ') + '.');
      continue;
    }

    spoken.push(line);
  }

  return spoken
    .join(' ')
    .replace(/\*\*(.*?)\*\*/g, '$1')
    .replace(/\*(.*?)\*/g, '$1')
    .replace(/^#+\s*/gm, '')
    .replace(/`/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}
